export default class LocalesApi {
  constructor() {
    this.data = ["RU", "EN"];
  }
  get() {
    return Promise.resolve({ data: this.data });
  }
}
